import { render } from "./BindProblem.vue?vue&type=template&id=12bbdfdf&scoped=true"
import script from "./BindProblem.vue?vue&type=script&lang=js"
export * from "./BindProblem.vue?vue&type=script&lang=js"

import "./BindProblem.vue?vue&type=style&index=0&id=12bbdfdf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12bbdfdf"]])

export default __exports__